export default {"src":"/blog/_next/static/media/tiktok.fae8c797.svg","height":800,"width":800};